/**
 * The document title for a page's own title. One that already names the site
 * (the home page's) is used as it is.
 */
export function pageTitle(title: string): string {
  return !title ? 'RubyInsights' : title.includes('RubyInsights') ? title : `${title} | RubyInsights`
}
